
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/[url_slug]/thank-you",
      function () {
        return require("private-next-pages/contact-us/[url_slug]/thank-you.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/[url_slug]/thank-you"])
      });
    }
  